import { render, staticRenderFns } from "./NavigationComponent.vue?vue&type=template&id=bf546bf8&"
import script from "./NavigationComponent.vue?vue&type=script&lang=js&"
export * from "./NavigationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports